module.exports = __webpack_public_path__ + "static/media/icon-logout.28ed4b9f.svg";